<template>
  <v-container fluid>
    <div>
      <h1 class="headline mt-2">Agent View</h1>
    </div>
    <v-layout row wrap>
      <v-flex xs4 class="text-xs-left">
        <span>
          <multiselect
            ref="suggest"
            v-model="view"
            v-validate="'required'"
            :data-vv-as="$t('How did you hear about us?')"
            name="suggest"
            :options="viewoptions"
            :searchable="false"
            :close-on-select="true"
            :show-labels="false"
          ></multiselect>
        </span>
      </v-flex>
      <v-flex xs8 class="text-xs-right">
        <span>
          <v-btn outline color="grey" class="ma-0 mb-1" @click="exportData">
            <em class="fas fa-file-export mr-1" />
            {{ $t('export') }}
          </v-btn>
        </span>
        <v-btn outline color="primary" :loading="loading" @click="showSearch = true"
          >Filter/Search by Date</v-btn
        >

        <v-dialog v-model="showSearch" persistent max-width="600" scrollable>
          <v-card>
            <div class="text-xs-right">
              <v-btn small flat fab :loading="loading" @click="showSearch = false">
                <v-icon>close</v-icon>
              </v-btn>
            </div>
            <v-divider></v-divider>
            <v-card-text max-height="600">
              <v-layout wrap>
                <v-flex xs12 sm6 class="px-1">
                  <div class="caption">Group</div>
                  <multiselect
                    v-model="filter.group"
                    class="mb-3"
                    :disabled="['only_me', 'only_group', 'only_subgroup'].includes(view_ticket)"
                    :options="agentGroupOptions"
                    label="groupname"
                    select-label
                    selected-label
                    :allow-empty="false"
                    :searchable="false"
                    deselect-label
                    track-by="groupname"
                    @input="onChangeGroup"
                  ></multiselect>
                </v-flex>
                <template v-if="filter.group && filter.group.id != null">
                  <v-flex xs12 sm6 class="px-1">
                    <div class="caption">Sub Group</div>
                    <multiselect
                      :key="`sub_${filter.group.id}`"
                      v-model="filter.subgroup"
                      class="mb-3"
                      :disabled="['only_me', 'only_subgroup'].includes(view_ticket)"
                      :options="agentSubGroupOptions"
                      label="subgroupname"
                      select-label
                      selected-label
                      :allow-empty="false"
                      :searchable="false"
                      deselect-label
                      track-by="subgroupname"
                      @input="onChangeSubGroup"
                    ></multiselect>
                  </v-flex>
                </template>
              </v-layout>

              <v-layout>
                <v-flex xs6>
                  <div>
                    <div class="caption">Start Date</div>
                    <v-layout>
                      <v-flex xs10>
                        <DatePickerWithoutButton v-model="selectedDate.start">
                          <div class="form-control">
                            <input type="text" :value="getDate(selectedDate.start)" readonly />
                          </div> </DatePickerWithoutButton
                      ></v-flex>
                      <v-flex xs2>
                        <v-btn icon @click="selectedDate.start = null">
                          <v-icon>close</v-icon></v-btn
                        >
                      </v-flex>
                    </v-layout>
                  </div></v-flex
                >
                <v-flex xs6>
                  <div>
                    <div class="caption">End Date</div>
                    <v-layout>
                      <v-flex xs10>
                        <DatePickerWithoutButton v-model="selectedDate.end">
                          <div class="form-control">
                            <input type="text" :value="getDate(selectedDate.end)" readonly />
                          </div> </DatePickerWithoutButton
                      ></v-flex>
                      <v-flex xs2>
                        <v-btn icon @click="selectedDate.end = null"> <v-icon>close</v-icon></v-btn>
                      </v-flex>
                    </v-layout>
                  </div></v-flex
                >
              </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" depressed :loading="loading" @click="onSearch">
                {{ $t('Search') }}
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
      <v-flex xs12>
        <div class="mb-2">
          <v-chip v-for="(item, k) in showFilter" :key="k" dark color="blue">{{ item }}</v-chip>
        </div>
      </v-flex>
    </v-layout>
    <v-data-table
      :headers="headers"
      :pagination.sync="pagination"
      :items="filteredAgents"
      class="elevation-1"
      hide-actions
      :loading="loading"
    >
      <template #items="props">
        <td>{{ props.index + 1 }}</td>
        <td>{{ props.item.name }}</td>
        <td style="cursor: pointer" @click="showUserDetail(props.item.adminid, '', props.item.all)">
          {{ props.item.all }}
        </td>
        <td
          style="cursor: pointer"
          @click="showUserDetail(props.item.adminid, 'pending', props.item.pending)"
        >
          {{ props.item.pending }}
        </td>
        <td
          style="cursor: pointer"
          @click="showUserDetail(props.item.adminid, 'answered', props.item.answered)"
        >
          {{ props.item.answered }}
        </td>
        <td
          style="cursor: pointer"
          @click="showUserDetail(props.item.adminid, 'closed', props.item.closed)"
        >
          {{ props.item.closed }} ({{ Number(props.item.averageclosetime).toFixed(2) }})
        </td>
        <td
          style="cursor: pointer"
          @click="showUserDetail(props.item.adminid, 'cancelled', props.item.cancelled)"
        >
          {{ props.item.cancelled }}
        </td>
        <td
          style="cursor: pointer"
          @click="
            showUserDetail(
              props.item.adminid,
              'cancelled by customer',
              props.item.cancelledbycustomer
            )
          "
        >
          {{ props.item.cancelledbycustomer }}
        </td>
        <td v-if="['106855151601601'].includes(selectedBot.pageid)">
          {{ formatAvg(props.item.firsttime / props.item.totalticket) }}
        </td>
        <td
          v-if="selectedBot.type == 'truecorp'"
          style="cursor: pointer"
          @click="showUserDetail(props.item.adminid, 'cancelled', props.item.success)"
        >
          {{ props.item.success }}
        </td>
        <td v-if="showCheckInCheckOutLogButton">
          <v-btn icon flat @click="handleShowCheckInCheckOutLog(props.item.adminid)">
            <v-icon>history</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>
    <v-dialog v-model="showDetail" width="600px">
      <v-card v-if="showDetail">
        <div class="text-xs-right">
          <v-btn small icon @click="showDetail = false">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <ticket-list
            v-model="showDetailUserid"
            :filter="showDetailStatus"
            :byadminid="true"
          ></ticket-list>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="checkInCheckOutDialogOpen" width="1000px" persistent>
      <v-card v-if="checkInCheckOutDialogOpen">
        <DialogCheckInCheckOut
          :selected-admin="selectedAdmin"
          @close="
            selectedAdmin = null
            checkInCheckOutDialogOpen = false
          "
        />
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
import datepicker from 'vuejs-datepicker'
import moment from 'moment'
import TicketList from '@/components/view/livechat/TicketList.vue'
import XLSX from 'xlsx'
import collect from 'collect.js'
import DatePickerWithoutButton from '@/components/elements/DatePickerWithoutButton.vue'
import DialogCheckInCheckOut from './DialogCheckInCheckOut'

const DateRangePicker = () => import('./DateRangePicker')
export default {
  components: {
    Multiselect,
    DateRangePicker,
    TicketList,
    DatePickerWithoutButton,
    DialogCheckInCheckOut
  },
  data() {
    return {
      responseAgent: [],
      view_ticket: '',
      view: 'Agents',
      viewoptions: ['Agents', 'Group', 'Sub Group', 'All'],
      showDetailStatus: '',
      showDetailUserid: '',
      showDetail: false,
      showSearch: false,
      filter: {
        group: {
          groupname: 'All',
          id: null
        }
      },
      agents: [],
      pagination: {
        rowsPerPage: 100
      },
      headers: [
        { text: 'No.', value: 'index' },
        { text: 'Name', value: 'index' },
        { text: 'All Ticket', value: 'all' },
        { text: 'Pending Ticket', value: 'pending' },
        { text: 'Answered Ticket', value: 'answered' },
        { text: 'Closed Ticket', value: 'closed' },
        { text: 'Cancelled Ticket', value: 'cancelled' },
        { text: 'Cancelled Ticket by customer', value: 'cancelledbycustomer' }
      ],
      selectedDate: {
        start: moment().format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD'),
        starttime: null,
        endtime: null
      },
      loading: true,
      checkInCheckOutDialogOpen: false,
      selectedAdmin: null
    }
  },
  computed: {
    showFilter() {
      var result = []

      if (this.filter.group && this.filter.group.groupname != 'All') {
        result.push(`Group: ${this.filter.group.groupname}`)
      }
      if (this.filter.subgroup && this.filter.subgroup.subgroupname != 'All') {
        result.push(`Sub Group: ${this.filter.subgroup.subgroupname}`)
      }
      if (this.filter.assignadminid) {
        result.push(`Name: ${this.filter.assignadminid}`)
      }
      if (this.selectedDate.start) {
        result.push(
          `Start Date: ${moment(this.selectedDate.start).format('DD/MM/YYYY')} ${
            this.selectedDate.starttime ? this.selectedDate.starttime : ''
          }`
        )
      }
      if (this.selectedDate.end) {
        result.push(
          `End Date: ${moment(this.selectedDate.end).format('DD/MM/YYYY')} ${
            this.selectedDate.endtime ? this.selectedDate.endtime : ''
          }`
        )
      }
      return result
    },

    filteredAgents() {
      var vm = this
      if (this.agents.length) {
        if (this.view == 'Customer') {
          return this.agents
        } else if (this.view == 'Group') {
          const grouped = collect(this.responseAgent).groupBy('admingroupid')
          var obj = []
          for (const [key, value] of Object.entries(JSON.parse(grouped.toJson()))) {
            var name = vm.agentGroup.find((el) => {
              return el.id == key
            })
            obj.push({
              ...this.calculateTicket(value).reduce((total, item) => {
                total['all'] = total['all'] || 0
                total['all'] += item.all
                total['averageclosetime'] = parseFloat(total['averageclosetime']) || 0
                total['averageclosetime'] += parseFloat(item.averageclosetime)
                total['cancelled'] = total['cancelled'] || 0
                total['cancelled'] += item.cancelled
                total['answered'] = total['answered'] || 0
                total['answered'] += item.answered
                total['cancelledbycustomer'] = total['cancelledbycustomer'] || 0
                total['cancelledbycustomer'] += item.cancelledbycustomer
                total['closed'] = total['closed'] || 0
                total['closed'] += item.closed
                total['pending'] = total['pending'] || 0
                total['pending'] += item.pending
                total['success'] = total['success'] || 0
                total['success'] += item.success
                return total
              }),
              name: name ? name.groupname : null
            })
          }

          return obj
        } else if (this.view == 'Sub Group') {
          const grouped = collect(this.responseAgent).groupBy('adminsubgroupid')
          var obj = []
          if (vm.agentSubGroup && vm.agentSubGroup.length) {
            for (const [key, value] of Object.entries(JSON.parse(grouped.toJson()))) {
              var name = vm.agentSubGroup.find((el) => {
                return el.id == key
              })
              obj.push({
                ...this.calculateTicket(value).reduce((total, item) => {
                  total['all'] = total['all'] || 0
                  total['all'] += item.all
                  total['averageclosetime'] = parseFloat(total['averageclosetime']) || 0
                  total['averageclosetime'] += parseFloat(item.averageclosetime)
                  total['cancelled'] = total['cancelled'] || 0
                  total['cancelled'] += item.cancelled
                  total['answered'] = total['answered'] || 0
                  total['answered'] += item.answered
                  total['cancelledbycustomer'] = total['cancelledbycustomer'] || 0
                  total['cancelledbycustomer'] += item.cancelledbycustomer
                  total['closed'] = total['closed'] || 0
                  total['closed'] += item.closed
                  total['pending'] = total['pending'] || 0
                  total['pending'] += item.pending
                  total['success'] = total['success'] || 0
                  total['success'] += item.success
                  return total
                }),
                name: name ? name.subgroupname : null
              })
            }
            return obj
          } else {
            return []
          }
        } else if (this.view == 'All') {
          var obj = []
          obj.push({
            ...this.calculateTicket(this.responseAgent).reduce((total, item) => {
              total['all'] = total['all'] || 0
              total['all'] += item.all
              total['averageclosetime'] = parseFloat(total['averageclosetime']) || 0
              total['averageclosetime'] += parseFloat(item.averageclosetime)
              total['cancelled'] = total['cancelled'] || 0
              total['cancelled'] += item.cancelled
              total['answered'] = total['answered'] || 0
              total['answered'] += item.answered
              total['cancelledbycustomer'] = total['cancelledbycustomer'] || 0
              total['cancelledbycustomer'] += item.cancelledbycustomer
              total['closed'] = total['closed'] || 0
              total['closed'] += item.closed
              total['pending'] = total['pending'] || 0
              total['pending'] += item.pending
              total['success'] = total['success'] || 0
              total['success'] += item.success
              return total
            }),
            name: 'All'
          })

          return obj
        } else {
          return this.agents
        }
      } else return []
    },
    ...mapGetters({
      selectedBot: 'selectedBot',
      agentGroup: 'getAgentGroup',
      loadingAgentGroup: 'getLoadingAgentGroup',
      agentSubGroup: 'getAgentSubgroup',
      loadingAgentSubGroup: 'getLoadingAgentSubgroup',

      loadingAgent: 'getLoadingAgent'
    }),

    agentGroupOptions() {
      return this.loadingAgentGroup
        ? []
        : [
            {
              groupname: 'All',
              id: null
            },
            ...this.agentGroup
          ]
    },
    agentSubGroupOptions() {
      if (!this.filter.group) {
        return []
      }
      var subgroup = this.agentSubGroup.filter((el) => {
        return el.admingroupid == this.filter.group.id
      })
      return this.loadingAgentSubGroup
        ? []
        : [
            {
              subgroupname: 'All',
              id: null
            },
            ...subgroup
          ]
    },
    showCheckInCheckOutLogButton() {
      let showButton = false
      if (['nt'].includes(this.selectedBot.type) && this.view === 'Agents') {
        showButton = true
      }

      return showButton
    }
  },

  async mounted() {
    this.loading = true
    try {
      this.initFilter()
      var filter = this.formatFilter()
      this.offset = 0
      var responseAgent = await this.getTicketsByAgent(filter)
      this.responseAgent = responseAgent.data
      if (responseAgent.data) {
        this.agents = this.calculateTicket(responseAgent.data)
      }

      if (['106855151601601'].includes(this.selectedBot.pageid)) {
        this.headers.push({ text: 'Average 1st response time', value: 'Average 1st response time' })
      }

      if (this.selectedBot.type == 'truecorp') {
        this.headers.push({ text: 'Success', value: 'success' })
      }

      if (['nt'].includes(this.selectedBot.type)) {
        this.headers.push({ text: '', value: '', sortable: false })
      }
    } catch (error) {
      console.error(error)
    }

    this.loading = false
  },
  methods: {
    getDate(date) {
      if (date) {
        return moment(date).format('DD/MM/YYYY')
      } else {
        return ''
      }
    },
    exportData() {
      let vm = this
      let header = 'data:text/csv;charset=utf-8,%EF%BB%BF'
      let csvContent = ''
      let orders = []
      let filename = 'AgentView'

      var json = []

      json = this.filteredAgents.map((el, k) => {
        return {
          No: k + 1,
          Name: el.name ? el.name : '-',
          'All Ticket': el.all ? el.all : '0',
          'Pending Ticket': el.pending ? el.pending : '0',
          'Answered Ticket': el.answered ? el.answered : '0',
          'Closed Ticket': el.closed ? el.closed : '0',
          'Cancelled Ticket': el.cancelled ? el.cancelled : '0',
          'Cancelled Ticket by customer': el.cancelledbycustomer ? el.cancelledbycustomer : '0',
          ...(vm.selectedBot.type == 'truecorp' ? { Success: el.success ? el.success : '0' } : {})
        }
      })

      var dataWS = XLSX.utils.json_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, filename + '.xlsx')
    },
    showUserDetail(id, status, value) {
      if (value) {
        this.showDetailUserid = id
        this.showDetailStatus = status
        this.showDetail = true
      }
    },
    formatFilter() {
      var data = {}

      if (this.filter.group && this.filter.group.id != null) {
        data.assigngroupid = this.filter.group.id
      }

      if (this.filter.subgroup && this.filter.subgroup.id != null) {
        data.assignsubgroupid = this.filter.subgroup.id
      }
      if (this.filter.assignadminid && this.filter.assignadminid != null) {
        data.assignadminid = this.filter.assignadminid
      }

      if (this.selectedDate.start) {
        data.starttime = moment(this.selectedDate.start).format('YYYY-MM-DD')
      }

      if (this.selectedDate.end) {
        data.endtime = moment(this.selectedDate.end).format('YYYY-MM-DD')
      }
      return data
    },
    formatAvg(secs) {
      const formatted = moment.utc(parseInt(secs) * 1000).format('H ชั่วโมง m นาที s วินาที')
      return formatted
    },
    onChangeGroup(val) {
      if (val.id) {
        this.$set(this.filter, 'subgroup', { id: null, subgroupname: 'All' })
      } else {
        this.$set(this.filter, 'subgroup', null)
      }
    },
    onChangeSubGroup(val) {},
    async onSearch() {
      this.loading = true
      try {
        var filter = this.formatFilter()
        this.offset = 0
        var responseAgent = await this.getTicketsByAgent(filter)
        this.responseAgent = responseAgent.data
        if (responseAgent.data) {
          this.agents = this.calculateTicket(responseAgent.data)
        }
      } catch (error) {
        console.log(error)
      }
      this.loading = false
      this.showSearch = false
    },
    calculateTicket(data) {
      var list = {}
      var agents = []
      data.map((el) => {
        if (list.hasOwnProperty(el.adminid)) {
          list[el.adminid].all += parseInt(el.amount)
          list[el.adminid].firsttime += parseInt(el.firsttime)
          list[el.adminid].totalticket += 1

          switch (el.status) {
            case 'pending':
              list[el.adminid].pending += parseInt(el.amount)
              break
            case 'answered':
              list[el.adminid].answered += parseInt(el.amount)
              break
            case 'closed':
              list[el.adminid].closed += parseInt(el.amount)
              list[el.adminid].averageclosetime = (
                parseFloat(el.closetime) / parseFloat(el.amount)
              ).toFixed(2)
              break
            case 'cancelled':
              list[el.adminid].cancelled += parseInt(el.amount)
              break
            case 'cancelled by customer':
              list[el.adminid].cancelledbycustomer += parseInt(el.amount)
              break
            case 'success':
              list[el.adminid].success += parseInt(el.amount)
              break
            default:
              break
          }
        } else {
          list[el.adminid] = {
            adminid: el.adminid,
            name: el.name,
            all: parseInt(el.amount),
            pending: 0,
            closed: 0,
            answered: 0,
            cancelled: 0,
            cancelledbycustomer: 0,
            success: 0,
            averageclosetime: 0,
            firsttime: 0,
            totalticket: 0
          }

          list[el.adminid].firsttime += parseInt(el.firsttime)
          list[el.adminid].totalticket += 1

          switch (el.status) {
            case 'pending':
              list[el.adminid].pending += parseInt(el.amount)
              break
            case 'closed':
              list[el.adminid].closed += parseInt(el.amount)
              list[el.adminid].averageclosetime = (
                parseFloat(el.closetime) / parseFloat(el.amount)
              ).toFixed(2)
              break
            case 'answered':
              list[el.adminid].answered += parseInt(el.amount)
              break
            case 'cancelled':
              list[el.adminid].cancelled += parseInt(el.amount)
              break
            case 'cancelled by customer':
              list[el.adminid].cancelledbycustomer += parseInt(el.amount)
              break
            case 'success':
              list[el.adminid].success += parseInt(el.amount)
              break
            default:
              break
          }
        }
      })

      for (const key in list) {
        if (list.hasOwnProperty(key)) {
          const element = list[key]
          agents.push(element)
        }
      }

      return agents
    },
    getTicketsByAgent(filter = null) {
      var data = {
        pageid: this.selectedBot.pageid,
        ...filter
      }
      return new Promise((resolve, reject) => {
        api.getTicketsByAgent(data, (error, response) => {
          if (error) {
            console.error(error)
            reject(error)
          }
          resolve(response)
        })
      })
    },
    initFilter() {
      var admingroupid = this.$store.state.admingroupid
      var adminsubgroupid = this.$store.state.adminsubgroupid
      var filter = {}
      var group = {}
      var subgroup = {}
      this.agentGroup.map((el) => {
        group[el.id] = el
      })
      this.agentSubGroup.map((el) => {
        subgroup[el.id] = el
      })

      // var group = this.agentGroup
      this.view_ticket = this.$store.state.privilege.view_ticket
      if (this.view_ticket == 'all') {
        // dont do shit
      } else if (this.view_ticket == 'only_me') {
        this.filter.assignadminid = this.$store.state.userid
        if (admingroupid || admingroupid === 0) {
          this.filter.group = group[admingroupid]
        }
        if (adminsubgroupid || adminsubgroupid === 0) {
          this.filter.subgroup = subgroup[adminsubgroupid]
        }
        if (this.agents) {
          this.filter.admin = this.agents.find((el) => el.adminid == this.$store.state.userid)
        }
      } else if (this.view_ticket == 'only_group') {
        Object.assign(filter, {
          assigngroupid: admingroupid
        })

        if (admingroupid || admingroupid === 0) {
          this.filter.group = group[admingroupid]
        }
      } else if (this.view_ticket == 'only_subgroup') {
        Object.assign(filter, {
          assignsubgroupid: adminsubgroupid
        })
        if (admingroupid || admingroupid === 0) {
          this.filter.group = group[admingroupid]
        }
        if (adminsubgroupid || adminsubgroupid === 0) {
          this.filter.subgroup = subgroup[adminsubgroupid]
        }
      }
    },
    handleShowCheckInCheckOutLog(adminId) {
      this.selectedAdmin = adminId
      this.checkInCheckOutDialogOpen = true
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ticket/Agent.vue